module.exports = __webpack_public_path__ + "static/img/11.cb75996.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/zh/11.png
// module id = f9cX
// module chunks = 0